module.exports = __webpack_public_path__ + "images/emoji/convenience_store.3946359a3d4e98a02111.png";